import { apiClient } from "../../../lib";
import { AddArtefactReviewerPayload, AddArtefactReviewerResponse, ArtefactCountResponse, ArtefactDetailsResponse, ArtefactEditPayload, ArtefactReviewersResponse, ArtefactsListResponse, CreateArtefactPayload, CreateArtefactResponse, EditArtefactResponse, UpdateArtefactReviewerPayload } from "../types";

export const artefactsApi = {

    fetchArtefacts: async ({ params }: { params: Record<string, string | string[] | boolean | number | undefined | null> }): Promise<ArtefactsListResponse> => {
        const searchParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append(key, String(v));
                });
            } else if (value) {
                searchParams.append(key, String(value));
            }
        });
        const query = searchParams.toString();
        const response = await apiClient.get(`/artefact?${query}`);
        return response.data;
    },

    addArtefacts: async (payload: CreateArtefactPayload): Promise<CreateArtefactResponse> => {
        const response = await apiClient.post(`/artefact`, payload);
        return response.data;
    },

    editArtefacts: async (artefactId: string, payload: ArtefactEditPayload): Promise<EditArtefactResponse> => {
        const response = await apiClient.put(`/artefact/${artefactId}`, payload);
        return response.data;
    },

    fetchArtefactsDetails: async (artefactId: string | null): Promise<ArtefactDetailsResponse> => {
        const response = await apiClient.get(`/artefact/${artefactId}`);
        return response.data;
    },

    fetchArtefactsDetailsCount: async (projectId: string | undefined): Promise<ArtefactCountResponse> => {
        const response = await apiClient.get(`/artefact/count`, { params: { project_id: projectId } });
        return response.data;
    },

    fetchReviewers: async (artefactId: string): Promise<ArtefactReviewersResponse> => {
        const response = await apiClient.get(`/artefact/${artefactId}/reviewers`);
        return response.data;
    },

    addReviewer: async (artefactId: string, payload: AddArtefactReviewerPayload): Promise<AddArtefactReviewerResponse> => {
        const response = await apiClient.post(`/artefact/${artefactId}/reviewers`, payload, { skipForbiddenRedirect: true });
        return response.data;
    },

    updateReviewer: async (artefactId: string, reviewerId: number, payload: UpdateArtefactReviewerPayload): Promise<any> => {
        const response = await apiClient.put(`/artefact/${artefactId}/reviewers/${reviewerId}`, payload, { skipForbiddenRedirect: true });
        return response.data;
    },

    deleteReviewer: async (artefactId: string, reviewerId: number): Promise<any> => {
        const response = await apiClient.delete(`/artefact/${artefactId}/reviewers/${reviewerId}`, { skipForbiddenRedirect: true });
        return response.data;
    }

};